import { z } from 'zod';

export const CAMPAIGN_STATUSES = ['draft', 'running', 'paused', 'cancelled', 'completed'] as const;
export type CampaignStatus = (typeof CAMPAIGN_STATUSES)[number];

export const CAMPAIGN_ITEM_SELECTION_MODES = ['auto', 'manual', 'hint'] as const;
export type CampaignItemSelectionMode = (typeof CAMPAIGN_ITEM_SELECTION_MODES)[number];

export const CAMPAIGN_ITEM_STATUSES = [
  'pending',
  'snapshotted',
  'enqueued',
  'consumed',
  'skipped',
] as const;
export type CampaignItemStatus = (typeof CAMPAIGN_ITEM_STATUSES)[number];

export const CampaignCreateSchema = z.object({
  clientId: z.string().uuid('Выберите клиента'),
  warehouseId: z.string().uuid('Выберите склад'),
  name: z.string().trim().min(1, 'Введите название').max(128),
  messageText: z.string().trim().max(8192),
  itemSelectionMode: z.enum(CAMPAIGN_ITEM_SELECTION_MODES),
});

export const CampaignUpdateSchema = z.object({
  name: z.string().trim().min(1).max(128).optional(),
  messageText: z.string().trim().max(8192).optional(),
  itemSelectionMode: z.enum(CAMPAIGN_ITEM_SELECTION_MODES).optional(),
});

export type CampaignCreateInput = z.infer<typeof CampaignCreateSchema>;
export type CampaignUpdateInput = z.infer<typeof CampaignUpdateSchema>;
